// extracted by mini-css-extract-plugin
module.exports = {"Global":"Global_Global__WEQAy","PhoneLink":"Global_PhoneLink__1Z2cs"};